export default __webpack_public_path__ + "static/media/element_spec_48.cb84afd1.webp";